export default __webpack_public_path__ + "static/media/IMPORTANCE OF LIFE LINE IN HEIGHT WORK SIMULATOR.2b6588da.JPG";